import { useSession, useModal } from "hooks"
import { Div, GoBack } from "ui"
import { useEffect } from "react"
import { BackContainer } from "./styles"

const Root = ({ children }) => {

  const { Modal } = useModal('onboarding')
  const { isLoggedIn, user } = useSession()

  useEffect(() => {
    if (!isLoggedIn) return

    const onboardingSeen = JSON.parse(localStorage.getItem('onboarding')) || []

    if (!onboardingSeen.includes(user.nickname)) {
      onboardingSeen.push(user.nickname)
      localStorage.setItem('onboarding', JSON.stringify(onboardingSeen))
      Modal.open()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn])

  return (
    <Div marginTop={15}>
      <BackContainer>
        <GoBack to='' />
      </BackContainer>
      {children}
    </Div>
  )
}

export default Root